<div class="one" fxLayout="column" [formGroup]="MatterPropertyDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.STRATAPLANNUMBER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.STRATAPLANNUMBER),
      }"
    >
      <mat-label>Strata Plan Number</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.STRATAPLANNUMBER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="STRATAPLANNUMBER"
      />
      @if (testBool && toolTipList.STRATAPLANNUMBER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.STRATAPLANNUMBER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.STRATAPLANNUMBER?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BYLAWTYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BYLAWTYPE),
      }"
    >
      <mat-label>By Law Type</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.BYLAWTYPE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="BYLAWTYPE"
      />
      @if (testBool && toolTipList.BYLAWTYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.BYLAWTYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.BYLAWTYPE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BYLAWNO),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BYLAWNO),
      }"
    >
      <mat-label>By Law No.</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.BYLAWNO?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="BYLAWNO"
      />
      @if (testBool && toolTipList.BYLAWNO) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.BYLAWNO.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.BYLAWNO?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="33"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SPECIALRESOLUTIONDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SPECIALRESOLUTIONDATE),
      }"
    >
      <mat-label>Resolution Date</mat-label>
      <input
        (dateInput)="ResolutionDatepicker('input', $event)"
        (dateChange)="ResolutionDatepicker('change', $event)"
        name="resolutiondatepicker"
        matInput
        [matDatepicker]="resolutiondatepicker"
        matTooltip="{{ toolTipList ? toolTipList.SPECIALRESOLUTIONDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SPECIALRESOLUTIONDATETEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="resolutiondatepicker"></mat-datepicker-toggle>
      <mat-datepicker #resolutiondatepicker></mat-datepicker>
      @if (testBool && toolTipList.SPECIALRESOLUTIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.SPECIALRESOLUTIONDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.SPECIALRESOLUTIONDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="34"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.AGGREGATIONOFENTITLEMENT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.AGGREGATIONOFENTITLEMENT),
      }"
    >
      <mat-label>Aggr. of Entitlement</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.AGGREGATIONOFENTITLEMENT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="AGGREGATIONOFENTITLEMENT"
      />
      @if (testBool && toolTipList.AGGREGATIONOFENTITLEMENT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.AGGREGATIONOFENTITLEMENT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.AGGREGATIONOFENTITLEMENT?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      class="pr-1"
      fxFlex="33"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TOTALUNITS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOTALUNITS),
      }"
    >
      <mat-label>Total Units</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.TOTALUNITS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="TOTALUNITS"
      />
      @if (testBool && toolTipList.TOTALUNITS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TOTALUNITS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TOTALUNITS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
      <mat-label>Annual Strata Levies</mat-label>
      <input
        matInput
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        formControlName="ANNUALSTRATALEVIES"
        [leadZero]="true"
      />
    </mat-form-field>
    <mat-form-field appearance="outline" class="pr-1" fxFlex="50">
      <mat-label>Levies Paid Until</mat-label>
      <input
        (dateInput)="LeviesDatepicker('input', $event)"
        (dateChange)="LeviesDatepicker('change', $event)"
        name="leviesdatepicker"
        matInput
        [matDatepicker]="leviesdatepicker"
        formControlName="STRATALEVIESPAIDUNTILTEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="leviesdatepicker"></mat-datepicker-toggle>
      <mat-datepicker #leviesdatepicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div fxFlex="100">
    <strong>Strata Title Record Holder</strong>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" class="pr-1" fxFlex="50">
      <mat-label>Name</mat-label>
      <input matInput formControlName="STRATATITLERECORDHOLDERNAME" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="pr-1" fxFlex="50">
      <mat-label>Email</mat-label>
      <input matInput formControlName="STRATATITLERECORDHOLDEREMAIL" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" class="pr-1" fxFlex="50">
      <mat-label>Phone</mat-label>
      <input matInput formControlName="STRATATITLERECORDHOLDERPHONE" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="pr-1" fxFlex="50">
      <mat-label>Address</mat-label>
      <input matInput formControlName="STRATATITLERECORDHOLDERADDRESS" />
    </mat-form-field>
  </div>
</div>
